import { useCotizador } from "context/apiContext";
import { useBenefitValidation } from "./BenefitValidationHook";
import { useSteps } from "hooks/useSteps";
import { TextsContext } from "context/textsContext";
import { useContext } from "react";
import { ERROR_TYPES } from "constants/validationConstants";
import { setErrorMessage } from "helpers/toolsHelper";

const useFormBenefitValidation = () => {

    const { texts } = useContext(TextsContext);
    const { errors, selectedBenefits } = useCotizador();
    const { getCurrentStepData, benefitsGenerator } = useSteps();

    const benefitValidator = useBenefitValidation(selectedBenefits);

    const validateBenefitSelection = (shouldCleanErrors = false) => {
        const currentStep = getCurrentStepData?.()?.step;
        const requiredBenefitsForStep = [...benefitsGenerator(currentStep)];
        const invalidBenefits = benefitValidator.getBenefitsThatAreNot(requiredBenefitsForStep);
        
        const validationErrors = { benefitsList: {} };
        const requiredFieldMessage = texts?.general_field_validation_required ?? 'This field is required';

        requiredBenefitsForStep.forEach(benefitKey => {
            const existingFieldError = errors?.benefitsList?.[benefitKey];
            const hasBlankError = existingFieldError?.blank;

            validationErrors.benefitsList[benefitKey] = existingFieldError ?? {};
            const isBenefitInvalid = invalidBenefits.includes(benefitKey);

            if (shouldCleanErrors) {
                if(hasBlankError) {
                    setErrorMessage(
                        validationErrors.benefitsList[benefitKey], 
                        ERROR_TYPES.BLANK, 
                        isBenefitInvalid ? requiredFieldMessage : null
                    );

                }
            } else {
                setErrorMessage(
                    validationErrors.benefitsList[benefitKey], 
                    ERROR_TYPES.BLANK, 
                    isBenefitInvalid ? requiredFieldMessage : null
                );
            }
        })
        return validationErrors;
    }

    return { validateBenefits: validateBenefitSelection }
}

export default useFormBenefitValidation